import React from 'react';
import EditIcon from '@material-ui/icons/Edit';
import { useDispatch } from "react-redux";
import { Card, Checkbox, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import { CONFIGURACIONTURNOS_PERMISOS } from '../../../../utils/permisos';
import { habilitarInhabilitarLicenciaProfesional, licenciasProfesionalesSeleccionar, licenciasProfesionalesUpdateDisabled } from '../../../../actions/turnos/licenciasProfesionales';
import { startAlerta } from '../../../../actions/ui/alertas';

const style = {
    cell: {
        padding: 8,
        textAlign: 'center',
    },
    iconButton: {
        width: 32,
        height: 32,
        padding: 0,
        marginTop: 0,
        marginBottom: 0,
    },
};

const optionsfecha = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
};

export const ListaLicencias = (props) => {
    const dispatch = useDispatch();
    const { setearVariosValores, setEditRegistro, validarSoloUnPermiso, permisosUser, items, cargada } = props;

    const handleEditItem = item => {
        dispatch( licenciasProfesionalesUpdateDisabled(false) );
        dispatch( licenciasProfesionalesSeleccionar(item) );
        setearVariosValores(item);
        setEditRegistro(true);
    }
    
    const handleEnabledParametrizacion = (idEfectorLicencias, nuevoEstado) => {
        if(nuevoEstado)
            dispatch( startAlerta('No se puede volver a habilitar una licencias, se debe crear nuevamente para que se eliminen o cancelen los turnos', "warning", `¡Error!`) );
        else
            dispatch( habilitarInhabilitarLicenciaProfesional(idEfectorLicencias, nuevoEstado) );
    }

    return (
        <>
            {cargada&&
                <Card >  
                    <TableContainer component={Paper}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell align="left"></TableCell>
                                    <TableCell align="left">Fecha Desde</TableCell>
                                    <TableCell align="left">Fecha Hasta</TableCell>
                                    <TableCell align="center">Tipo Licencia</TableCell>
                                    <TableCell align="left">Fecha Deshabilitado</TableCell>
                                    <TableCell align="left" style={style.cell}>Habilitado</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {items.length > 0
                                    ?
                                        items.map((item) => (
                                            <TableRow key={item.idEfectorLicencias}>
                                                <TableCell align="left" style={style.cell}>
                                                    <IconButton style={{ padding: 0, margin:0 }}
                                                        onClick={(e) => handleEditItem(item)}
                                                        disabled={!validarSoloUnPermiso(permisosUser, CONFIGURACIONTURNOS_PERMISOS.MODIFICACION)}
                                                        color="primary"
                                                        aria-label="Editar"
                                                    >
                                                        <EditIcon style={style.iconButton} />
                                                    </IconButton>
                                                </TableCell>
                                                <TableCell align="left">
                                                    {new Date(item.fechaDesde).toLocaleString(
                                                        "es",
                                                        optionsfecha
                                                    )}
                                                </TableCell>
                                                <TableCell align="left">
                                                    {new Date(item.fechaHasta).toLocaleString(
                                                        "es",
                                                        optionsfecha
                                                    )}
                                                </TableCell>
                                                <TableCell align="center" >
                                                    {item.tipoLicencia.descripcion}
                                                </TableCell>
                                                <TableCell align="left">
                                                    {item.fecProCBaja
                                                        ?
                                                            new Date(item.fecProCBaja).toLocaleString(
                                                                "es",
                                                                optionsfecha)
                                                        :
                                                            null
                                                    }
                                                </TableCell>
                                                <TableCell align="left" style={style.cell} >
                                                    <Checkbox
                                                        name="habilitado"
                                                        checked={!item.fecProCBaja}
                                                        disabled={!validarSoloUnPermiso(permisosUser, CONFIGURACIONTURNOS_PERMISOS.MODIFICACION)}
                                                        onClick={() => handleEnabledParametrizacion(item.idEfectorLicencias, item.fecProCBaja ? true : false)}
                                                    />
                                                </TableCell>
                                            </TableRow>
                                        ))
                                    :
                                        <TableRow style={{ height: 50 }}>
                                            <TableCell colSpan={12} style={{textAlign: '-webkit-center'}}> Sin Registros</TableCell>
                                        </TableRow>
                                }
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Card>
            }  
        </>
     );
}